import React from 'react';
import PricingTable from '../../PricingTable/PricingTable';

const PricingPage = ({
	create_checkout_session_endpoint,
	stripe_public_key,
	stripe_product_essential_id,
	stripe_product_advanced_id,
	stripe_product_ultimate_id
}) => (
	<div>
		<div className="container p-4 pt-4 lg:py-14 md:px-20">
			<PricingTable
				create_checkout_session_endpoint={create_checkout_session_endpoint}
				stripe_public_key={stripe_public_key}
				stripe_product_essential_id={stripe_product_essential_id}
				stripe_product_advanced_id={stripe_product_advanced_id}
				stripe_product_ultimate_id={stripe_product_ultimate_id}
			/>
		</div>
	</div>
);

export default PricingPage;
